import axios from 'axios'
import { getUrlParam, addUrlParam } from '@/utils'
// import { toLogin } from '@/utils'

const createInstance = (baseURL) => {
  const instance = axios.create({
    baseURL,
    timeout: 60 * 1000,
    withCredentials: true,
  })
  instance.addRequestInterceptor = (onFulfilled, onRejected) => {
    instance.interceptors.request.use(onFulfilled, onRejected)
  }
  instance.addResponseInterceptor = (onFulfilled, onRejected) => {
    instance.interceptors.response.use(onFulfilled, onRejected)
  }
  return instance
}
const baseURL = 'https://jobs.wps.cn'
const driveBaseURL = process.env.NODE_ENV === 'production' ? 'https://drive.wps.cn' : 'https://365.kdocs.cn/3rd/drive'

const meeting = createInstance('https://meeting.wps.cn')
const rili = createInstance('https://rili.wps.cn')
const drive = createInstance(driveBaseURL)
const account = createInstance('https://account.wps.cn')
const email = createInstance('https://email.wps.cn')
const weboffice = createInstance('https://web.wps.cn')
const jobs = createInstance(baseURL)
const api = createInstance('https://api.wps.cn')
const plus = createInstance('https://plus.wps.cn')

const addJobsChannelInterceptor = (instance) => {
  instance.addRequestInterceptor((config) => {
    const jobsChannel = getUrlParam(window.location.href, 'jobs_channel')
    if (jobsChannel === 'inner') {
      config.url = addUrlParam(config.url, 'jobs_channel', 'inner')
    }
    return config
  })
}
// addJobsChannelInterceptor(meeting)
addJobsChannelInterceptor(jobs)

// 添加响应拦截器
// meeting.addResponseInterceptor(
//   (response) => {
//     return response.data
//   }, (err) => {
//     const { response } = err
//     if (response?.status === 403) {
//       return toLogin()
//     }
//     return Promise.reject(err)
//   }
// )

// 添加请求拦截器
// meeting.addRequestInterceptor((config) => {
//   config.headers['x-accept-timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone
//   return config
// }, (err) => Promise.reject(err))

export { baseURL, meeting, rili, drive, account, email, weboffice, jobs, api, plus }